import React from 'react';
import { Tooltip } from '@patternfly/react-core';
import { CheckIcon } from '@patternfly/react-icons';

import './styles.scss';

type PositionIndicatorProps = {
  /** 1-based position in the list */
  position: number;
  /** When true, shows check icon instead of number with green background */
  isCompleted?: boolean;
  /** Optional tooltip content shown on hover */
  tooltip?: React.ReactNode;
};

const PositionIndicator: React.FC<PositionIndicatorProps> = ({
  position,
  isCompleted = false,
  tooltip,
}) => {
  const indicator = (
    <span
      className={`position-indicator ${
        isCompleted ? 'position-indicator--completed' : ''
      }`}
      aria-hidden
    >
      {isCompleted ? (
        <span className="position-indicator__inner">
          <CheckIcon className="position-indicator__icon" />
        </span>
      ) : (
        position
      )}
    </span>
  );

  if (tooltip) {
    return (
      <Tooltip content={tooltip} position="top">
        {indicator}
      </Tooltip>
    );
  }

  return indicator;
};

export default PositionIndicator;
